import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import { ComponentProps } from './interfaces';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  max-width: 350px;
  width: 100%;

  @media ${device.isMobile} {
    max-width: none;
  }
`;

export const Label = styled.label`
  align-self: stretch;
  font-family: VIC;
  font-weight: 600;
  overflow-wrap: break-word;
  margin-bottom: 8px;
  color: ${colors.blueGrey};
`;

export const HintLabel = styled(Label)`
  font-weight: 400;
  margin-top: 8px;
  color: ${colors.blueGrey75};
`;

export const ErrorLabel = styled(Label)`
  color: ${colors.red};
  margin-top: 8px;
  font-weight: 400;
`;

export const LinkLabel = styled(Label)`
  margin-top: 8px;
  font-weight: 400;
  text-decoration: underscore;
  color: ${colors.brown};
  border: 0;
  text-decoration: underline;
  font-size: 1rem;
  text-align: left;
  padding: 0;
  cursor: pointer;
`;

type Props = ComponentProps & {
  error: string;
};

export const Input = styled.input<Props>`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  align-self: stretch;
  height: 46px;
  border-radius: 2px;
  font-size: 1rem;
  font-family: VIC;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  outline: 0px !important;
  color: ${colors.blueGrey};
  cursor: active;
  background-color: ${colors.white};
  border: solid 1px ${colors.blueGrey};
  padding: 0 16px;

  &[aria-invalid='true'] {
    border-color: ${colors.red};
  }

  &[disabled] {
    background-color: ${colors.darkGrey10};
    cursor: not-allowed;
    border: solid 1px ${colors.darkGrey75};
  }

  &:active,
  &:focus {
    border-color: ${colors.orange};
  }

  &[autocomplete="off"] {
    /* Disable native safari autofill suggestion */
    &::-webkit-contacts-auto-fill-button,
    &::-webkit-credentials-auto-fill-button {
      visibility: hidden;
      pointer-events: none;
      position: absolute;
      right: 0;
    }

    /* Hide webkit browsers native search clear button */
    &[type='search']::-webkit-search-decoration,
    &[type='search']::-webkit-search-cancel-button,
    &[type='search']::-webkit-search-results-button,
    &[type='search']::-webkit-search-results-decoration {
      -webkit-appearance: none;
    }
  }
`;
